import React, { useState } from "react";
import { Box, Container, Text, VStack } from "@chakra-ui/react";
import NavBar from "../../../Components/Navbar/NavBar";
import SalesCN from "./SalesCN";
import ReportCN from "./ReportCN";
import cn_logo from "../../../Assets/CNPH.jpg";

const CN = () => {
  const [selectedOption, setSelectedOption] = useState("Sales");
  
  const handleTabClick = (tab) => {
    setSelectedOption(tab);
  };

  const renderContent = () => {
    switch (selectedOption) {
      case "Sales":
        return <SalesCN content="Sales CN" color="gray" />;
      case "Reports":
        return <ReportCN content="Reports CN" />;
      default:
        return <SalesCN content="Sales CN" color="gray" />;
    }
  };

  return (
    <Box h="100vh" bg="gray.50" overflow="hidden">
      <NavBar 
        tabIndicatorColor="gray.800" 
        logo={cn_logo} 
        onTabClick={handleTabClick} 
      />
      
      <Box bg="white" w="100%" h="calc(100vh - 60px)" overflow="hidden">
        {renderContent()}
      </Box>
    </Box>
  );
};

export default CN;
